
import { mapGetters } from "vuex";
import { SistemaMixin } from "@/modules/Application";
import TableApp from "@/components/Table/Table2";
import Pencil from "vue-material-design-icons/Pencil.vue";
import swal from "sweetalert";
import FilterFields from "@/components/FilterFields";
import Close from "vue-material-design-icons/FileCancel.vue";
import Search from "vue-material-design-icons/Magnify.vue";
import TransmitIcon from "vue-material-design-icons/SendCheckOutline";
import PackageCheck from "vue-material-design-icons/CubeSend";
import PdfIcon from "vue-material-design-icons/FilePdfBox.vue";
import XmlIcon from "vue-material-design-icons/Download.vue";
import _ from "lodash";
import VueSelect from "vue-select";

export default {
  name: "mdfe-lista",
  mixins: [SistemaMixin],
  components: {
    TableApp,
    Pencil,
    FilterFields,
    Close,
    Search,
    TransmitIcon,
    PackageCheck,
    VueSelect,
    PdfIcon,
    XmlIcon,
  },
  data() {
    return {
      ufs: [],
      ufsSearched: [],
      cidades: [],
      ufSelected: null,
      selectedMdfe: null,
      cidadeEncerramento: null,
      fields: [
        {
          label: "Número",
          field: "numero",
          type: "text",
          slot: true,
          width: "10%",
          sortable: false,
        },
        {
          label: "Status",
          field: "status",
          sortable: true,
          slot: true,
        },
        {
          label: "Data de Jornada",
          field: "data_jornada",
          sortable: false,
          slot: true,
          type: "date",
          dateInputFormat: "yyyy-MM-dd HH:mm:ss",
          dateOutputFormat: "dd-MM-yyyy",
        },
        {
          label: "Data de Emissão",
          field: "data_emissao",
          sortable: false,
          slot: true,
          type: "date",
          dateInputFormat: "yyyy-MM-dd HH:mm:ss",
          dateOutputFormat: "dd-MM-yyyy",
        },
        {
          label: "Motorista",
          field: "motorista",
          type: "text",
          slot: true,
          width: "15%",
          sortable: false,
        },
        {
          label: "Veículo",
          field: "veiculo",
          type: "text",
          slot: true,
          width: "15%",
          sortable: false,
        },
        {
          label: "Ações",
          field: "actions",
          sortable: false,
          width: "8%",
          slot: true,
        },
      ],
    };
  },
  async created() {
    const [{ data: ufsData }] = await Promise.all([
      this.$http.post("/sistema/get-uf"),
    ]);
    this.ufs = ufsData;
    this.ufsSearched = ufsData;
  },
  methods: {
    handleEditMdfe(data) {
      swal({
        title: "Deseja editar o MDFe?",
        text: "Você ira ser direcionado para a pagina de edição aguarde...",
        icon: "info",
        buttons: {
          cancel: {
            text: "Cancelar",
            value: "cancel",
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: "OK",
            visible: true,
            closeModal: false,
          },
        },
        dangerMode: false,
        closeModal: false,
        closeOnClickOutside: false,
      }).then(async (value) => {
        if (value === "cancel") {
          swal.close();
          swal.stopLoading();
          return;
        }

        await this.$http
          .post("/mdfe/get-by-id", {
            id_mdfe: data.id_mdfe,
          })
          .then((response) => {
            swal.stopLoading();
            swal.close();
            this.$toast.info("Você será redirecionado agora");
            this.$router.push({
              name: "novaMdfe",
              params: { mdfeData: { ...response.data, id_mdfe: data.id_mdfe } },
            });
          })
          .catch(() => {
            swal.stopLoading();
            this.$toast.error("Erro ao solicitar o endpoint do MDFe");
            swal.close();
          });
      });
    },
    transmitir(data) {
      swal({
        title: "Deseja realizar a transmissão do MDFe?",
        text: "Aguarde, pois será enviada o MDFe para transmissão!",
        icon: "info",
        buttons: {
          cancel: {
            text: "Cancelar",
            value: "cancel",
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: "OK",
            visible: true,
            closeModal: false,
          },
        },
        dangerMode: false,
        closeModal: false,
        closeOnClickOutside: false,
      }).then(async (value) => {
        if (value === "cancel") {
          swal.close();
          swal.stopLoading();
          return;
        }
        await this.$http
          .post("/mdfe/transmissao", {
            id_mdfe: data.id_mdfe,
          })
          .then((result) => {
            if (result["data"]["mdfe-url"]) {
              window.open(result["data"]["mdfe-url"], "_blank");
            }
            swal.stopLoading();
            swal.close();
            this.$refs.vendas.refresh();
            this.$toast.success("MDFe transmitido com sucesso!");
          })
          .catch(() => {
            swal.stopLoading();
            swal.close();
          });
      });
    },
    consultarMdfe(data) {
      swal({
        title: "Deseja consultar o MDFe?",
        icon: "info",
        buttons: {
          cancel: {
            text: "Cancelar",
            value: "cancel",
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: "Sim",
            visible: true,
            closeModal: false,
          },
        },
        dangerMode: false,
        closeModal: false,
        closeOnClickOutside: false,
      }).then(async (value) => {
        if (value === "cancel") {
          swal.close();
          swal.stopLoading();
          return;
        }

        const consulta = await this.$http.post("/mdfe/consultar", {
          id_mdfe: data.id_mdfe,
        });
        this.$toast.success(consulta.data.xMotivo);
        swal.stopLoading();
        swal.close();
      });
    },
    searchUf(search, ufNumber) {
      this.ufsSearched = this.ufs.filter((uf) =>
        uf.sigla.toLowerCase().includes(search.toLowerCase())
      );
    },
    onSearchCidades(search, loading) {
      if (!this.ufSelected) {
        this.$toast.error("Informe primeiro o UF");
        return;
      }
      if (search.length) {
        loading(true);
        this.searchCidades(loading, search, this);
      }
    },
    searchCidades: _.debounce(async (loading, cidade, vm) => {
      const { data } = await vm.$http.post("/sistema/get-cidade-by-uf", {
        uf: vm.ufSelected.sigla,
        cidade,
      });
      vm.cidades = data;
      if (loading) loading(false);
    }, 350),
    selectMdfe(id_mdfe) {
      console.log(id_mdfe);
      this.selectedMdfe = id_mdfe;
    },
    async encerrarMdfe() {
      this.addLoadingToButton("encerrar_mdfe");
      if (!this.cidadeEncerramento) {
        this.$toast.error("Selecione a cidade para encerrar a MDFe!");
        this.removeLoadingToButton("encerrar_mdfe");
        return;
      }
      try {
        await this.$http.post("/mdfe/encerrar", {
          id_mdfe: this.selectedMdfe,
          uf: this.ufSelected.sigla,
          id_cidade: this.cidadeEncerramento.id_cidade,
        });
      } catch (error) {
        console.log(error);
        this.removeLoadingToButton("encerrar_mdfe");
      }
      this.$bvModal.hide("encerrarMdfe");
      this.selectedMdfe = null;
      this.ufSelected.sigla = null;
      this.cidadeEncerramento.id_cidade = null;
      this.removeLoadingToButton("encerrar_mdfe");
      this.$toast.success("MDFe encerrado com sucesso!");
      this.$refs.mdfeList.refresh();
    },
    imprimirPDF(data) {
      swal({
        title: "Deseja gerar o pdf do MDFe?",
        text: "Aguarde, pois será gerado o pdf automaticamente!",
        icon: "info",
        buttons: {
          cancel: {
            text: "Cancelar",
            value: "cancel",
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: "OK",
            visible: true,
            closeModal: false,
          },
        },
        dangerMode: false,
        closeModal: false,
        closeOnClickOutside: false,
      }).then(async (value) => {
        if (value === "cancel") {
          swal.close();
          swal.stopLoading();
          return;
        }
        await this.$http
          .post("/mdfe/imprimir", {
            id_mdfe: data.id_mdfe,
          })
          .then((result) => {
            const resultData = result["data"]["mdfe_url"];
            if (resultData) {
              window.open(resultData, "_blank");
            }
            swal.stopLoading();
            swal.close();
            this.$toast.success("PDF gerado com sucesso!");
          })
          .catch(() => {
            swal.stopLoading();
            swal.close();
          });
      });
    },
    cancelMdfe(data) {
      this.getRequestAdmin(() => {
        swal({
          title: "Deseja cancelar o MDFe?",
          text: "Informe a justificativa do cancelamento!",
          icon: "info",
          content: "input",
          buttons: {
            cancel: {
              text: "Cancelar",
              value: "cancel",
              visible: true,
              closeModal: true,
            },
            confirm: {
              text: "OK",
              visible: true,
              closeModal: false,
            },
          },
          dangerMode: false,
          closeModal: false,
          closeOnClickOutside: false,
        }).then(async (value) => {
          if (value === "cancel") {
            swal.close();
            swal.stopLoading();
            return;
          }

          if (value.length < 15) {
            swal.stopLoading();
            this.$toast.warning(
              "A justificativa tem que possuir no mínimo 15 caracteres"
            );
            return;
          }

          await this.$http
            .post("/mdfe/cancelar", {
              id_mdfe: data.id_mdfe,
              justificativa: value,
            })
            .then(() => {
              swal.stopLoading();
              swal.close();
              this.$toast.success("MDFe cancelado com sucesso!");
              this.$refs.mdfeList.refresh();
            })
            .catch(() => {
              swal.stopLoading();
              swal.close();
            });
        });
      })
    },
    handleDeleteMdfe(data) {
      this.$swal
        .fire({
          icon: "warning",
          title: "Excluir a MDFe?",
          showCancelButton: true,
          confirmButtonText: `Sim`,
          cancelButtonText: `Não`,
          confirmButtonColor: "#f64e60",
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            await this.$http.post("/mdfe/delete", {
              mdfes: [
                {
                  id_mdfe: data.id_mdfe,
                },
              ],
            });
            this.$refs.mdfeList.refresh();
            this.$toast.success("MDFe excluída!");
          }
        });
    },
    lerJsonMotorista(dados) {
      const json = JSON.parse(dados);
      return json.motorista.nome;
    },
    lerJsonVeiculo(dados) {
      const json = JSON.parse(dados);
      return json.veiculo.descricao + " - " + json.veiculo.placa;
    },
    gerarlXml(data) {
      swal({
        title: "Deseja realizar a visualização do xml?",
        text: "Aguarde, pois será gerado o xml automaticamente!",
        icon: "info",
        buttons: {
          cancel: {
            text: "Cancelar",
            value: "cancel",
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: "OK",
            visible: true,
            closeModal: false,
          },
        },
        dangerMode: false,
        closeModal: false,
        closeOnClickOutside: false,
      }).then(async (value) => {
        if (value === "cancel") {
          swal.close();
          swal.stopLoading();
          return;
        }

        if (data.xml_cancelado) {
          window.open(
            process.env.VUE_APP_DIGITAL_BASE_URL + data.xml_cancelado,
            "_blank"
          );
          swal.close();
          swal.stopLoading();
          return;
        }
        window.open(
          process.env.VUE_APP_DIGITAL_BASE_URL + data.arquivo_xml,
          "_blank"
        );
        swal.close();
        swal.stopLoading();
        return;
      });
    },
  },
  computed: {
    ...mapGetters(["layoutConfig", "itsblocked"]),
    config() {
      return this.layoutConfig();
    },
  },
  async mounted() { },
};
